import * as React from 'react';
import * as PropTypes from 'prop-types';
import Pagination from 'components/Pagination';
import Select from 'components/Select';

const CustomPaginationComponent = ({
  fetchNextPage,
  pageSizeOptions,
  paginationOptions,
  showPaginationSizeInput,
}) => {
  return (
    <div className="boo">
      <div className="d-flex flex-column flex-md-row">
        <Pagination
          currentPage={paginationOptions.number + 1}
          pagesNumber={paginationOptions.totalPages}
          onChange={(pageNumber) => {
            fetchNextPage({ page: pageNumber - 1 });
          }}
        />

        {showPaginationSizeInput && (
          <div className="col pt-3 pt-md-0 col-md-3 col-lg-2">
            <Select
              value={paginationOptions.size}
              options={pageSizeOptions.map((size) => ({
                value: size,
                label: size,
              }))}
              withoutHelpWrapper={true}
              isFull={true}
              onChange={({ value }) => {
                fetchNextPage({ size: value });
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

CustomPaginationComponent.propTypes = {
  paginationOptions: PropTypes.shape({
    number: PropTypes.number,
    totalPages: PropTypes.number,
    size: PropTypes.number,
  }),
  fetchNextPage: PropTypes.func.isRequired,
  pageSizeOptions: PropTypes.array.isRequired,
  showPaginationSizeInput: PropTypes.bool,
};

export default CustomPaginationComponent;
